import React from "react";
import { Outlet } from "react-router-dom";
import Box from "@mui/system/Box";

export default function DashboardHome() {
  return (
    <Box>
      <Outlet />
    </Box>
  );
}
